import React from 'react';
import { string, node, any, func } from 'prop-types';
import { RadioGroup as MuiRadioGroup } from '@material-ui/core';
function RadioGroup(props) {
  return /*#__PURE__*/React.createElement(MuiRadioGroup, props);
}
RadioGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: node.isRequired,
  /** A CSS class to add to the root node of the component. */
  className: string,
  /**
   * The default input element value. Use when the component is not controlled.
   */
  defaultValue: any,
  /**
   * The name used to reference the value of the control.
   */
  name: string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing event.target.value (string).
   */
  onChange: func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: any
};
export default RadioGroup;